export default __webpack_public_path__ + "static/image5-449fe624239a31c0db6ee8b54a93b92f.gif";